module.exports = "/* You can add global styles to this file, and also import other style files */\nbody{\n    background-color: black!important;\n}\nh1, h2, h3{\n    color: white!important;\n}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles